//role/saveRole.do
/**
 * 角色+权限接口
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 新增或者编辑角色
	 * @param {String} roleid 角色id //新增传 ''  编辑传id
	 * @param {String} rolename  角色名称
	 * @param {String} memo 备注
	 */
	saveRole: (roleid, rolename, memo, success, failure) => {
		Axios.post('role/saveRole.do', {
			roleid,
			rolename,
			memo
		}, success, failure);
	},
	/**
	 * 获取所有角色list
	 */
	getAllRole: (success, failure) => {
		Axios.post('/role/getAllRole.do', {}, success, failure);
	},
	/**
	 * 关联角色的接口
	 * @param {string} userId  用户id
	 * @param {String} roleIds  角色ids
	 */
	bindUserAndRole: (userId, roleIds, success, failure) => {
		Axios.post('/user/bindUserAndRole.do', {
			userId,
			roleIds
		}, success, failure);
	},
	/**
	 * 获取用户已绑定角色id集合
	 * @param {String} userId  用户id  
	 */
	getRoleIdsByUserId: (userId, success, failure) => {
		Axios.post('/role/getRoleIdsByUserId.do',{
			userId
		}, success, failure);
	},
	/**
	 * 单位list
	 */
	getAllUnit: (success, failure) => {
		Axios.post('/role/getAllRole.do', {}, success, failure);
	},
	/**
	 * 删除角色  
	 * roleId 角色id
	 */
	deleteRole: (roleId, success, failure) => {
		Axios.post('/role/deleteRoleById.do', {
			roleId
		}, success, failure);
	},
	//---------权限--------------
	/**
	 * 	添加权限
	 * @param {String} roleId 角色id
	 * @param {String} rights 权限     rightid1,rightid2,rightid3,rightid4,rightid5
	 * 
	 */
	addRoleRight: (roleId, rights, success, failure) => {
		Axios.post('/role/addRoleRight.do', {
			roleId,
			rights
		}, success, failure);
	},
}